import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { from } from 'rxjs';
import { tap, map, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
    CoreActionTypes,
    StoreToken,
    StoreUserProfile,
    SaveDriverName,
    SetLang, StoreDriver,
} from '../actions';
import { getDriver } from '../selectors';
import { AppState } from '../registration';
import { offlineQueueDB } from '../../../service-worker/offline-queue.database.typed';
import { LocalStorageUtil } from "../../shared/utilities/local-storage.util";

@Injectable()
export class StorageEffects {
    constructor(
        private actions$: Actions,
        private store: Store<AppState>
    ) {
    }


    storeTokenDB$ = createEffect(() => this.actions$.pipe(
        ofType(CoreActionTypes.STORE_TOKEN),
        map((action: StoreToken) => action.payload),
        tap(token => offlineQueueDB.jwt.put(token, 1))
    ), { dispatch: false });


    storeUserProfile$ = createEffect(() => this.actions$.pipe(
        ofType(CoreActionTypes.STORE_USER_PROFILE),
        map((action: StoreUserProfile) => action.payload),
        tap(userProfile => LocalStorageUtil.setItemObject('userProfile', userProfile))
    ), { dispatch: false });


    setOfflineToken$ = createEffect(() => this.actions$.pipe(
        ofType(CoreActionTypes.OFFLINE_HYDRATE_STORE),
        mergeMap(() => from(offlineQueueDB.jwt.get(1))),
        map(token => new StoreToken(token))
    ));


    saveDriverName$ = createEffect(() => this.actions$.pipe(
        ofType(CoreActionTypes.SAVE_DRIVER_NAME),
        map((action: SaveDriverName) => action.payload),
        tap(savedName => LocalStorageUtil.setItemObject('savedName', savedName))
    ), { dispatch: false });


    setChangedLang$ = createEffect(() => this.actions$.pipe(
        ofType(CoreActionTypes.SET_LANG_SUCCESS),
        map((action: SetLang) => action.payload),
        filter(payload => !payload.initial),
        withLatestFrom(this.store.select(getDriver)),
        tap(([payload, driver]) => {
            const newDriver = {
                ...driver,
                locale: payload.lang
            };
            this.store.dispatch(new StoreDriver(newDriver));
        })
    ), { dispatch: false });


}
